module.exports = __webpack_public_path__ + "img/investissement2.98d95929.jpg";